"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var hooks_1 = require("../../hooks");
var style_1 = require("../../style");
var data_entry_1 = require("../data-entry");
var layout_1 = require("../layout");
var styles_1 = require("./styles");
var QuickJumper = function (props) {
    var totalPages = props.totalPages, currentPage = props.currentPage, onChange = props.onChange;
    var theme = style_1.useTheme();
    var _a = hooks_1.useDerivedState(function () { return "" + currentPage; }, [currentPage]), pendingPage = _a[0], setPendingPage = _a[1];
    var styles = styles_1.getQuickJumperStyles(theme);
    return (react_1.jsx(layout_1.Flex, { alignItems: "center", gap: 8 },
        react_1.jsx("div", { css: styles.common }, "Page"),
        react_1.jsx(data_entry_1.Input, { type: "number", size: "large", inputProps: {
                min: 0,
                max: totalPages,
                onBlur: function (e) {
                    var pageNumber = e.target.valueAsNumber;
                    if (pageNumber < 1) {
                        onChange(1);
                    }
                    else if (pageNumber > totalPages) {
                        onChange(totalPages);
                    }
                    else {
                        onChange(pageNumber);
                    }
                },
                onKeyDown: function (e) {
                    if (e.key === 'Enter') {
                        var pageNumber = e.currentTarget.valueAsNumber;
                        if (pageNumber < 1) {
                            onChange(1);
                        }
                        else if (pageNumber > totalPages) {
                            onChange(totalPages);
                        }
                        else {
                            onChange(pageNumber);
                        }
                    }
                },
            }, onChange: setPendingPage, error: currentPage > totalPages || currentPage < 1, value: pendingPage }),
        react_1.jsx("div", { css: styles.common },
            "of ",
            react_1.jsx("span", { css: styles.totalPages }, totalPages))));
};
exports.default = QuickJumper;
